export default __webpack_public_path__ + "static/media/element_51.5d422608.jpg";